document.addEventListener('DOMContentLoaded', function() {
    const scrollBar = document.querySelector('.scrollbar__thumb');
    const scrollTrack = document.querySelector('.scrollbar__track');
    const textWithIcons = document.querySelector('.text-with-icons__inner');

    if (textWithIcons) {
        const scrollWidth = textWithIcons.scrollWidth;
        if (textWithIcons.scrollWidth <= textWithIcons.clientWidth) {
            scrollTrack.style.display = 'none';
        }
        scrollBar.style.width = `${(textWithIcons.clientWidth / scrollWidth) * 100}%`;

        function textWithIconsListener() {
            if (textWithIcons.scrollWidth <= textWithIcons.clientWidth) {
                scrollTrack.style.display = 'none';
            } else {
                scrollTrack.style.display = 'block';
            }

            const scrollWidth = textWithIcons.scrollWidth;
            const scrollLeft = textWithIcons.scrollLeft;
            const clientWidth = textWithIcons.clientWidth;
            const thumbWidth = (clientWidth / scrollWidth) * 100;
            const thumbPosition = (scrollLeft / scrollWidth) * 100;

            scrollBar.style.width = `${thumbWidth}%`;
            scrollBar.style.left = `${thumbPosition}%`;
        }

        textWithIcons.addEventListener('scroll', textWithIconsListener);
        window.addEventListener('resize', textWithIconsListener);
    }
});